import React, { Component } from 'react'
import { MainContainer } from './styledComponents'

export default class PageContainer extends Component {
  render() {
    const { children, className } = this.props
    return <MainContainer className={className}>{children}</MainContainer>
  }
}
